import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { View, Text, Platform, StyleSheet, TouchableOpacity } from 'react-native';

import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import timeUtils from '../../utils/timeUtils';
import BirthdaySelectModal from './BirthdaySelectModal';

function MyDateOfBirthInput(props) {
  const { translation, date = null, locale, onSelect, error, width } = props;
  const [showModal, setShowModal] = useState(false);

  const dateAsNumber = date === null || date === undefined || date === '' ? null : Number(date);

  const labels = {
    birth_date: Platform.OS === 'web' ? translation.dob_required : translation.app_personal_edittext_dob,
  };

  const selectBirthdate = (value) => {
    setShowModal(false);
    onSelect(value);
  };

  return (
    <>
      <TouchableOpacity
        onPress={() => setShowModal(true)}
        style={[
          styles.birthdayContainer,
          {
            width,
          },
        ]}
        testID="birth-date"
      >
        {error ? (
          <View style={styles.noValueContainer}>
            <View style={styles.inputContainer}>
              <Text style={styles.birthdayText}>{labels.birth_date}</Text>
              <View style={styles.redLine} />
            </View>
          </View>
        ) : Number.isInteger(dateAsNumber) ? (
          <View>
            <View style={styles.labelContainer}>
              <Text style={styles.dobFloatingLabel}>{labels.birth_date}</Text>
            </View>
            <View style={styles.inputContainer}>
              <Text style={styles.blackText}>{timeUtils.formatBirthdate(dateAsNumber)}</Text>
              <View style={styles.grayLine} />
            </View>
          </View>
        ) : (
          <View style={styles.noValueContainer}>
            <View style={styles.inputContainer}>
              <Text style={styles.birthdayText}>{labels.birth_date}</Text>
              <View style={styles.grayLine} />
            </View>
          </View>
        )}
      </TouchableOpacity>
      {showModal ? (
        <BirthdaySelectModal
          translation={translation}
          date={dateAsNumber}
          onSelect={selectBirthdate}
          onCancel={() => setShowModal(false)}
          locale={locale}
        />
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  birthdayContainer: {
    height: 73,
    minHeight: 73,
    maxHeight: 73,
  },
  noValueContainer: {
    paddingTop: 19,
  },
  labelContainer: {
    height: 19,
    marginTop: Layout.usePantryTabs ? -8 : -4,
    marginBottom: Layout.usePantryTabs ? 4 : 3,
  },
  inputContainer: {
    height: 29,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  dobFloatingLabel: {
    color: Colors.grayText,
    fontSize: 14,
    marginBottom: 0,
  },
  birthdayText: {
    color: Platform.OS === 'web' ? Colors.grayText : Colors.veryDarkGray,
    fontSize: 14,
    marginBottom: 6,
  },
  blackText: {
    color: Colors.black,
    fontSize: 16,
    marginBottom: 6,
  },
  redLine: {
    borderBottomColor: Colors.brightRed,
    borderBottomWidth: 1,
    marginTop: Platform.OS === 'web' ? 0 : 8,
  },
  grayLine: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.grayBorder,
    marginTop: Platform.OS === 'web' ? 0 : 8,
  },
});

MyDateOfBirthInput.propTypes = {
  translation: PropTypes.objectOf(PropTypes.any).isRequired,
  onSelect: PropTypes.func.isRequired,
  date: PropTypes.string, // unix timestamp
  locale: PropTypes.string.isRequired,
  width: PropTypes.any, // number or string, %
  error: PropTypes.any, // sometime boolean
  onboarding: PropTypes.bool,
};

export default MyDateOfBirthInput;
